<script>
export default {
  name: "SessionBasePriceTotal",
};
</script>

<script setup>
import { computed, toRefs } from "vue";

import { formattedPriceFromCentsWithoutCents } from "@/util/formatter";

const props = defineProps({
  orderData: {
    type: Object,
    default: () => ({}),
  },
});

const { orderData } = toRefs(props);

const totalAcademicFees = computed(() => {
  const basePrice = orderData.value?.base_price;
  const prices = [
    basePrice?.class_academic_fees_price_in_cents,
    basePrice?.internships_price_in_cents,
    basePrice?.events_price_in_cents,
  ].filter(Number.isFinite);

  return prices.length
    ? `${formattedPriceFromCentsWithoutCents(
        prices.reduce((acc, curr) => acc + curr, 0)
      )}`
    : "-";
});

const leftSideInformation = computed(() => {
  const orderBasePrice = orderData.value?.base_price;
  return {
    "TOTAL ACADEMIC FEES (SUB TOTAL)": totalAcademicFees.value,
    "Classes Fee": Number.isFinite(
      orderBasePrice?.class_academic_fees_price_in_cents
    )
      ? `${formattedPriceFromCentsWithoutCents(
          orderBasePrice?.class_academic_fees_price_in_cents
        )}`
      : "-",
    "Internship Fee": Number.isFinite(
      orderBasePrice?.internships_price_in_cents
    )
      ? `${formattedPriceFromCentsWithoutCents(
          orderBasePrice?.internships_price_in_cents
        )}`
      : "-",
    "Event Price": Number.isFinite(orderBasePrice?.events_price_in_cents)
      ? `${formattedPriceFromCentsWithoutCents(
          orderBasePrice?.events_price_in_cents
        )}`
      : "-",
  };
});

const rightSideInformation = computed(() => {
  const basePrice = orderData.value?.base_price;
  return {
    Housing: Number.isFinite(basePrice?.housing_price_in_cents)
      ? `${formattedPriceFromCentsWithoutCents(
          basePrice?.housing_price_in_cents
        )}`
      : "-",
    "Group Flight": Number.isFinite(basePrice?.group_flight_price_in_cents)
      ? `${formattedPriceFromCentsWithoutCents(
          basePrice?.group_flight_price_in_cents
        )}`
      : "-",
    Insurance: Number.isFinite(basePrice?.insurance_price_in_cents)
      ? `${formattedPriceFromCentsWithoutCents(
          basePrice?.insurance_price_in_cents
        )}`
      : "-",
    "Public Transportation": Number.isFinite(
      basePrice?.public_transportation_price_in_cents
    )
      ? `${formattedPriceFromCentsWithoutCents(
          basePrice?.public_transportation_price_in_cents
        )}`
      : "-",
  };
});
</script>

<template>
  <div
    class="px-6 py-4 space-y-2 space-x-4 flex flex-col bg-blue-200 md:pt-2 md:pb-4 md:items-center md:flex-row sm:justify-between"
  >
    <div
      v-for="(price, label) in leftSideInformation"
      :key="label"
      class="group items-start flex justify-between md:flex-col md:justify-normal"
    >
      <span class="ml-2 font-semibold text-sm md:text-md md:ml-0">
        {{ label }}
      </span>
      <div class="flex">
        <span class="text-sm md:text-md">
          {{ price }}
        </span>
      </div>
    </div>
    <div
      class="hidden mx-4 self-stretch w-[3px] h-20 bg-blue-100 md:inline-block"
    ></div>
    <div
      v-for="(price, label) in rightSideInformation"
      :key="label"
      class="group items-start flex justify-between md:flex-col md:justify-normal"
    >
      <span class="ml-2 font-semibold text-sm md:text-md md:ml-0">
        {{ label }}
      </span>
      <div class="flex">
        <span class="text-sm md:text-md">
          {{ price }}
        </span>
      </div>
    </div>
  </div>
</template>
